import React from "react";
import Modal from "react-bootstrap/Modal";
import linkedinIcon from "../../images/linkedin-icon.png";
import gmailIcon from "../../images/gmail-icon.png";

const DevModal = (props) => {
  // const [profileModal, setProfileModal] = useState(props.profileModal);
  return (
    <div>
      <Modal
        show={props.devModal}
        // onHide={profileModalClose}
        onHide={() => props.setDevModal(false)}
        centered={props.start ? false : true}
        size="sm"
      >
        <Modal.Header
          closeButton
          className="modal-header border-0"
          style={{ padding: "0 15px" }}
        >
          <div
            className="chatAppNameBig"
            style={{ marginTop: "10px", fontSize: "45px" }}
          >
            {/* <p>Talk'n Talk</p> */}
            GupShup
            <div>
              <p>by</p>
              <p>
                <span>Nadeem Mansha</span>
              </p>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body
          style={{
            justifyContent: "center",
            display: "flex",
            textAlign: "center",
            padding: "10px",
          }}
        >
          <div>
            <p
              style={{
                margin: "0",
                fontSize: "18px",
                fontFamily: "Work sans",
                fontWeight: "600",
              }}
            >
              Nadeem Mansha built this chat application using MERN for learning
              purposes.
            </p>
            <p
              style={{
                margin: "5px 0 0 0",
                fontSize: "10px",
                fontFamily: "Work sans",
                fontWeight: "600",
              }}
            >
              This is not the final version, still work to be done.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ border: 0, justifyContent: "center" }}>
          <div style={{ width: "170px" }}>
            <img
              src={linkedinIcon}
              alt="linkedin"
              style={{
                // borderRadius: "100%",
                width: "25px",
                margin: "0 5px",
              }}
            />
            <a
              href="https://www.linkedin.com/in/nadeem-mansha-28185923a"
              className="DevName"
            >
              Nadeem Mansha{" "}
            </a>
            {"\n"}
          </div>
          <br />
          <div style={{ width: "170px" }}>
            <img
              src={gmailIcon}
              alt="linkedin"
              style={{
                // borderRadius: "100%",
                width: "25px",
                margin: "0 5px",
                // position: 'absolute'
              }}
            />
            <a href="mailto:nadeemmanshadev@gmail.com" className="DevMail">
              Nadeem Mansha
            </a>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DevModal;
